import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  LoggingService
} from '@com-delta-idp/mnx-utils';
import { Observable, throwError } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';
import { SBW_TIMEOUT } from '../constants/common.constants';
import { EndpointKeys, IDP_APPS } from '../constants/urls.constants';
import { CatalogApiResponse } from '../models/core-apis/catalog-api.interfaces';

@Injectable({ providedIn: 'root' })
export class CatalogApiService {
  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private logging: LoggingService
  ) {}

  getCatalogApi(cacheKey: string): Observable<CatalogApiResponse> {
    const transactionIdPrefix = cacheKey || `ui-${uuidv4()}`;
    const headers: HttpHeadersPayload = {
      channelId: 'DCOM',
      Applicationid: 'DC',
      transactionId: `${transactionIdPrefix}_${Date.now()}`
    };
    return new ApiBuilder<string, CatalogApiResponse>(this.http, this.appConfig)
      .app(IDP_APPS.BOOK_WIDGET)
      .endpointKey(EndpointKeys.CATALOG_API_URL)
      .method(HttpRequestMethods.GET_HEADERS)
      .httpHeaders(headers)
      .timeOut(SBW_TIMEOUT.PE_AE)
      .errorHandler(this._handleError.bind(this))
      .create();
  }

  private _handleError(error: HttpErrorResponse): Observable<never> {
    this.logging.log(error.message);
    return throwError(error);
  }
}
